module.exports = __webpack_public_path__ + "img/eye-mature-2-fatty-acids.2962dc36.jpg";